import { render, staticRenderFns } from "./bitda-home-content.vue?vue&type=template&id=bf4546a6&"
import script from "./bitda-home-content.vue?vue&type=script&lang=js&"
export * from "./bitda-home-content.vue?vue&type=script&lang=js&"
import style0 from "./bitda-home-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports